import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from '../../../tables'

export const SystemPolicyName = 'system'
export const SystemUserName = 'system.user'

// TODO ver si puedo eliminar readPermissions de aca, no necesito todos los permissions
export const systemPermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.ADMIN, actions: [Action.GET_ALL, Action.GET, Action.GET_BY_PARAMS, Action.GET_BY_IDS] },
    { tableName: TableName.COMPANIES, actions: [Action.GET_ALL, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE] },
    { tableName: TableName.FISCAL_DOCUMENTS, actions: [Action.GET_ALL, Action.GET, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE, Action.REMOVE] },
    { tableName: TableName.REQUESTS, actions: [Action.GET_ALL, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE, Action.REMOVE] },
    { tableName: TableName.SALE_ORDERS, actions: [Action.GET_ALL, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE] },
    { tableName: TableName.HOARD_ORDERS, actions: [Action.GET_ALL, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE] },
    { tableName: TableName.USERS, actions: [Action.GET_ALL, Action.GET, Action.GET_BY_PARAMS, Action.GET_BY_IDS, Action.SAVE, Action.REMOVE] },
])
